module.exports = __webpack_public_path__ + "static/img/蒙版组 313@2x.0f1ed515.png";